import Grid from '@material-ui/core/Grid';
import { createStyles, makeStyles, Theme, ThemeProvider, Tooltip, Typography } from '@material-ui/core';

import Button from '@material-ui/core/Button';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';

import ErrorOutlinedIcon from '@material-ui/icons/ErrorOutlined';

import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { baseTheme } from '../../../../theme';
import PostDatePicker from './post-date-picker';
import DeletePostButton from '../../action-buttons/delete-post-button';
// import PrintPageButton from '../../action-buttons/print-page-button';
import FaqActionButton from '../../action-buttons/tips-faq-button';
import GroupInputField from '../../group-input-field';
import { setSelectedPostDate, setPostGroup } from '../../../../store';
import {
  setLinkURL,
  setPostedStatus,
  setPostTags,
  setPostTitle,
  setPostUpdates,
  setSelectedPostAction,
} from '../../../../store/posts/actions';
import { updatePost } from '../../../../services/posts';
import { withStyles } from '@material-ui/styles';
import moment from 'moment/moment';

interface IPostComponentProps {
  sticky: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    postHeader: {
      padding: '10px',
    },
    publicBorder: {
      borderBottom: `solid 3px ${theme.palette.primary.main}`,
    },
    privateBorder: {
      borderBottom: `solid 3px ${theme.palette.secondary.main}`,
    },
    staticBorder: {
      borderBottom: `solid 3px ${theme.palette.text.primary}`,
    },
    publicColor: {
      color: theme.palette.primary.main,
    },
    privateColor: {
      color: theme.palette.secondary.main,
    },
    staticColor: {
      color: theme.palette.text.primary,
    },
    disabledColor: {
      color: theme.palette.text.disabled,
    },
    errorColor: {
      color: theme.palette.error.main,
    },
    fixed: {
      backgroundColor: theme.palette.background.default,
      zIndex: 100,
      width: '66.25%',
      position: 'fixed',
      left: '33.4%',
      top: '0',
      paddingTop: '15px',
    },
    seatFiller: {
      height: '100px',
    },
    columnSpacer: {
      padding: theme.spacing(1),
    },
    rowSpacerLg: {
      marginBottom: theme.spacing(2),
    },
    rowSpacer: {
      marginBottom: theme.spacing(1),
    },
    rowXtraSpacer: {
      marginTop: theme.spacing(3),
    },
    rowItemSpacer: {
      marginRight: theme.spacing(1),
    },
    inviteControls: {
    },
    button: {
      width: '100%',
    },
    publicBG: {
      backgroundColor: theme.palette.primary.main,
    },
    privateBG: {
      backgroundColor: theme.palette.secondary.main,
    },
    staticBG: {
      backgroundColoer: theme.palette.text.primary,
      color: theme.palette.text.primary,
    },
    whiteText: {
      color: theme.palette.background.default,
    },
    selectMenuOverrides: {
      color: theme.palette.background.default,
    },
    saveInfo: {
      fontWeight: 'bold',
      textAlign: 'right',
    },
    heightControl: {
      height: '50px',
    },
    centerizer: {
      alignContent: 'center',
      justifyContent: 'center',
    },
    headerNoteColumn: {
      alignContent: 'center',
      justifyContent: 'center',
      paddingBottom: theme.spacing(1),
    },
    headerNote: {
      backgroundColor: theme.palette.text.primary,
      padding: theme.spacing(1),
      alignContent: 'center',
      justifyContent: 'center',
    },
    headerNoteText: {
      color: theme.palette.background.paper,
      fontSize: '1em',
      textAlign: 'center',
    },
  }),
);

export default function PostHeader(props: IPostComponentProps) {
  const { sticky } = props;
  const classes = useStyles(baseTheme);
  const dispatch = useDispatch();
  const postDetails = useSelector((state: any) => state.posts.selected);
  const currUser = useSelector((state: any) => state.auth.currUser);
  const listConfig = useSelector((state: any) => state.posts.listConfig);
  const tags = useSelector((state: any) => state.posts.tags);
  const [doneButtonDisabled, setDoneButtonDisabled] = useState<boolean>(false);
  const [linkUrlIncorrectFormat, setLinkUrlIncorrectFormat] = useState<boolean>(false);

  const tagList: any[] = tags;

  const handleSetDate = (value: any) => {
    setSelectedPostDate(dispatch, { id: postDetails.id, date: value });
  };

  const handlePostedChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    updatePost({
      id: postDetails.id,
      posted: !postDetails.posted,
      liveTime: Date.now().toString(),
    });
    setPostedStatus(dispatch, { id: postDetails.id, posted: !postDetails.posted });
    setPostUpdates(dispatch, { ...postDetails, posted: !postDetails.posted });
  };

  const handleGroupSelectionOpen = (arg: any) => {
    setDoneButtonDisabled(true);
  };

  const handleGroupTypeChange = (group: any) => {
    setPostGroup(dispatch, { group, id: postDetails.id, public: group?.type === 'Public' });
    setPostUpdates(dispatch, { ...postDetails, group, public: group?.type === 'Public' });
    setDoneButtonDisabled(false);
  };

  const handlePostTitleSave = () => {
    setPostUpdates(dispatch, postDetails);
    updatePost({ id: postDetails.id, title: postDetails.title, tags: postDetails.tags });
  };

  const handlePostTitleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPostTitle(dispatch, { id: postDetails.id, title: event.target.value });
  };

  const handleLinkURLChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setLinkURL(dispatch, { id: postDetails.id, linkUrl: event.target.value });
  };

  const handleLinkURLSave = () => {
    const urlExpression = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/gi;
    const urlRegex = new RegExp(urlExpression);
    if (postDetails.linkUrl === '' || postDetails.linkUrl.match(urlRegex)) {
      setLinkUrlIncorrectFormat(false);
      setPostUpdates(dispatch, postDetails);
      updatePost({ id: postDetails.id, linkUrl: postDetails.linkUrl });
    } else {
      setLinkUrlIncorrectFormat(true);
    }
  };

  const handleTagsInputChange = (event: any, value: any) => {

  };

  const handleTagsChange = (event: any, value: any) => {
    setPostTags(dispatch, { id: postDetails.id, tags: value });
  };

  const handleTagsSave = (value: any) => {
    setPostUpdates(dispatch, postDetails);
    updatePost({ id: postDetails.id, title: postDetails.title, tags: postDetails.tags });
  };

  const handlePostComplete = () => {
    setPostUpdates(dispatch, postDetails);
    dispatch(setSelectedPostAction(null));
  };

  const backgroundConfig = (classA: any, classB: any, classC: any) => {
    return postDetails.public === true
      ? classA
      : postDetails.group?.type === 'Closed'
        ? classB
        : classC;
  };

  const isPostable =
    postDetails.group?.type !== 'Private'
      || !postDetails.group?.type ? false : true;

  const typeResolver = postDetails.public === true
    ? 'Public'
    : postDetails.group?.type === 'Closed'
      ? 'Private'
      : 'Static';

  const colorizer = (theme: any) => postDetails.public === true
    ? theme.palette.primary.main
    : postDetails.group?.type === 'Closed'
      ? theme.palette.secondary.main
      : theme.palette.text.primary;

  const HTMLTooltip = withStyles((theme: Theme) => ({
    tooltip: {
      backgroundColor: theme.palette.background.default,
      color: colorizer(theme),
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(12),
      border: `1px solid ${colorizer(theme)}`,
    },
  }))(Tooltip);

  const PostHelpNotification = (props: any) => (
    <Typography>
      {props.content}
    </Typography>
  );

  const postHelpContent = postDetails.public !== true && postDetails.group?.type !== 'Closed'
    ? 'You must assign a public or closed group to make this post live.'
    : '';

  return (
    <Grid item container
      className={`${classes.postHeader} ${backgroundConfig(classes.publicBorder, classes.privateBorder, classes.staticBorder)} ${backgroundConfig(classes.publicColor, classes.privateColor, classes.staticColor)} ${sticky ? classes.fixed : null}`}>
      <Grid item container direction="column" xs={10} className={classes.columnSpacer}>
        <Grid item container>
          <Grid item container>
            <DeletePostButton
              currUserId={currUser.uid}
              postId={postDetails.id}
              postTitle={postDetails.title}
              postType={typeResolver}
              listConfig={listConfig} />
            {/* <PrintPageButton /> */}
            <FaqActionButton
              postType={typeResolver}
            />
            <Grid item container xs={1}></Grid>
            <Grid
                item
                container
                direction="column"
                xs={9}
                className={classes.headerNoteColumn}
            >
              <Grid item container className={classes.headerNote}>
                <Typography className={classes.headerNoteText}>
                  To keep any post private, so only you can see it,
                  simply keep the group field empty.<br/>
                  Private posts are your personal journal and a great way to get started.
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid item container className={classes.rowSpacer} spacing={1}>
          <Grid item xs={3}>
            <PostDatePicker
              date={postDetails.date}
              setSelectedDate={handleSetDate}
              postType={typeResolver} />
          </Grid>

          <Grid item container xs={9}>
            <GroupInputField
              data={postDetails}
              onOpen={handleGroupSelectionOpen}
              handleSaveCallback={handleGroupTypeChange}
              postType={typeResolver} />
          </Grid>

        </Grid>

        <Grid item container className={classes.rowSpacer}>
          <Grid item xs={12}>
            <TextField
              label="Title"
              variant="outlined"
              fullWidth
              value={postDetails.title}
              onBlur={handlePostTitleSave}
              onChange={handlePostTitleChange}
              size="small"
            />
          </Grid>
        </Grid>

        <Grid item container className={classes.rowSpacer} spacing={1}>

          <Grid item xs={12}>
            <Autocomplete
              freeSolo
              multiple
              id="tag-input"
              options={tagList}
              getOptionLabel={(option: any) => option}
              renderInput={params =>
                <TextField {...params} label="Tags" variant="outlined" size="small" />}
              value={postDetails.tags}
              onChange={handleTagsChange}
              onInputChange={handleTagsInputChange}
              onBlur={handleTagsSave}
            />
          </Grid>
        </Grid>

        <Grid item container className={classes.rowSpacer} spacing={1}>
            <Grid item xs={12}>
                <TextField
                    label="Link"
                    variant="outlined"
                    fullWidth
                    value={postDetails.linkUrl}
                    onBlur={handleLinkURLSave}
                    onChange={handleLinkURLChange}
                    size="small"
                />
            </Grid>
            {linkUrlIncorrectFormat &&
            <Typography color="error">Link is not correctly formatted.</Typography>
            }
        </Grid>

      </Grid>
      {/* <Grid item container direction="column" xs={9}>

      </Grid> */}
      <Grid item container xs={2} className={classes.columnSpacer}>
        {/* <Grid item xs={12} className={classes.seatFiller}></Grid> */}
        <Grid item container xs={12} className={classes.heightControl}>
          <Grid item xs={6} container className={`${classes.centerizer}`}>
              {postHelpContent &&
              <HTMLTooltip
                  arrow
                  title={postHelpContent ? <PostHelpNotification content={postHelpContent}/> : ''}>
                  <ErrorOutlinedIcon color="error"/>
              </HTMLTooltip>}
          </Grid>
          <Grid item xs={6} className={classes.centerizer}>
            <FormGroup>
              <FormControlLabel
                control={<Switch name="posted" checked={postDetails.posted} color={backgroundConfig('primary', 'secondary', 'text')} onChange={handlePostedChange} />}
                label={postDetails.posted ? 'Live' : 'Not Live'}
                labelPlacement="bottom"
                className={`${backgroundConfig(classes.publicColor, classes.privateColor, classes.staticColor)}`}
                disabled={isPostable}
              />
            </FormGroup>
          </Grid>
        </Grid>
        <Grid item xs={12} className={`${classes.centerizer}`}>
          <Button
            variant="contained"
            size="medium"
            disabled={doneButtonDisabled}
            onClick={handlePostComplete}
            className={`${classes.button}
              ${backgroundConfig(`${classes.publicBG} ${classes.whiteText}`,
              `${classes.privateBG} ${classes.whiteText}`,
              classes.staticBG)}`}>
            Done
          </Button>
        </Grid>
        <Grid item className={classes.saveInfo} xs={12}>
          Saved: <br />{moment(postDetails.updated).format('MM/DD/YYYY h:mm a')}
        </Grid>
      </Grid>
    </Grid>
  );
}
